import React, { useState } from "react";
import "../assets/css/InventoryFilter.scss"; // Ensure correct path

const InventoryFilter = () => {
    const [selectedDropdown, setSelectedDropdown] = useState(null);

    const filterOptions = {
        displayName: ["4.75", "5.00", "5.62", "6.62", "7.75 X 7.00", "8.38", "9.62", "9.62 X 8.75", "6.75"],
        lobe: ["4/5", "5/6", "6/7", "7/8", "8/9"],
        stage: ["11.7", "12.0", "2.2", "3.1", "4.0", "4.3", "5.3", "5.9", "6.9", "7.0", "8.3", "8.4", "8.8", "9.4", "9.5"],
        bearingHousing: ["IB Stb", "Screw On Stb", "Slick Sleeve Stb", "True Slick"],
        bendHousing: ["Adjustable", "Fixed"],
        bendAngle: ["0.00", "0.39", "0.78", "1.00", "1.15", "1.25", "1.50", "1.75", "1.83", "2.00", "2.12", "2.25"],
        bitThread: ["Box", "Pin"],
        bitConnection: ["3 1/2 REG", "4 1/2 IF-PD", "4 1/2 REG", "4 1/2 REG-SBB", "5 1/2 FH-PD", "5 5/8 REG", "5 5/8 REG-PD", "7 5/8 REG"],
        tsDescription: [
            '4.75" TOP SUB (3 1/2 IF)', '5.00" TOP SUB (XT39)', '5.00" IB TOP SUB (XT39)', '5.00" TOP SUB (DS42)', 
            '5.625" TOP SUB (XT39)', '6.50" TOP SUB (4 1/2 XH)', '6.625" TOP SUB (4 1/2 IF)', '7.00" TOP SUB (4 1/2 REG)'
        ],
        bladeSize: ["0", "5.875", "6", "6.125", "6.375", "6.5", "7.375", "7.625", "7.75", "8"],
    };

    const toggleDropdown = (category) => {
        setSelectedDropdown(selectedDropdown === category ? null : category);
    };

    return (
        <div className="inventory-container">
            <div className="dropdown-filters">
                {Object.keys(filterOptions).map((category, index) => (
                    <div key={category} className="filter-section">
                        <div className="filter-item" onClick={() => toggleDropdown(category)}>
                            {category.replace(/([A-Z])/g, " $1").trim()} ▼
                        </div>

                        {selectedDropdown === category && (
                            <div className="filter-dropdown">
                                {filterOptions[category].map((option) => (
                                    <div key={option} className="filter-option">
                                        {option}
                                    </div>
                                ))}
                            </div>
                        )}

                        {index !== Object.keys(filterOptions).length - 1 && <div className="divider" />}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InventoryFilter;
